import cx from 'classnames'
import { ImageProps } from 'next/image'
import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import * as SC from './styled'

export type ColumnSectionCardProps = {
  className?: string
  image?: ImageProps
  title: string
  text: string
  link: string
}

const ColumnSectionCard: FC<ColumnSectionCardProps> = ({
  className,
  image,
  title,
  text,
  link,
}) => {
  const { t } = useTranslation()

  return (
    <SC.ColumnSectionCard
      className={cx('ColumnSectionCard', className)}
      href={t(link as any)}
      target="_blank"
    >
      {image && <SC.Image {...image} />}
      <SC.Title>{t(title as any)}</SC.Title>
      <SC.Text>{t(text as any)}</SC.Text>
    </SC.ColumnSectionCard>
  )
}

export default ColumnSectionCard
